export default function(age) {
  return {
    type: "SET_AGE",
    age
  }
}



// WEBPACK FOOTER //
// ./src/actions/setAge.js